/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const ClockCheck = [
  ["path", { d: "M12 6v6l4 2" }],
  ["path", { d: "M22 12a10 10 0 1 0-11 9.95" }],
  ["path", { d: "m22 16-5.5 5.5L14 19" }]
];

export { ClockCheck as default };
//# sourceMappingURL=clock-check.js.map
